/**
 * Returns promise that will be rejected with Timeout error if not resolved in time
 * @param ms timeout value in milliseconds. if <= 0, will be immediatly rejected
 * @param promise
 * @param errorFactory function to create the error when timeout occurs
 */
export function promiseTimeout(ms, promise, errorFactory = () => new Error(`Timeout after ${ms}ms`)) {
    const startTime = new Date();
    if (ms <= 0) {
        const error = errorFactory({
            timeout: ms,
            startTime,
        });
        return Promise.reject(error);
    }
    const timeout = new Promise((resolve, reject) => {
        const id = setTimeout(() => {
            clearTimeout(id);
            const error = errorFactory({
                timeout: ms,
                startTime,
            });
            reject(error);
        }, ms);
    });
    return Promise.race([promise, timeout]);
}
